export const isLoadingNotifications = (state, conversation_guid) => {
  return state.app_notifications.loading;
};

export const getNotifications = state => {
  return state.app_notifications.notifications;
};

export const hasNewNotifications = state => {
  return state.app_notifications.notifications.filter(notification => notification["unread"]).length > 0;
};

export const unreadNotifications = state => {
  return state.app_notifications.notifications.filter(notification => notification["unread"]);
};